import { useTranslation } from 'react-i18next';

const CARD_COUNT = 3;
const cardIcons = ['ri-book-open-line', 'ri-search-line', 'ri-smartphone-line'];

export default function MaterialPhilosophy() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          {String(t('materials.philosophy.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('materials.philosophy.title')}
          </h2>
          {String(t('materials.philosophy.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="space-y-5">
          {String(t('materials.philosophy.description1')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] md:text-[17px] text-foreground-700 tracking-[0.04em] leading-relaxed">{__s}</p>))}
          {String(t('materials.philosophy.description2')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] md:text-[17px] text-foreground-700 tracking-[0.04em] leading-relaxed">{__s}</p>))}
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {Array.from({ length: CARD_COUNT }, (_, idx) => (
            <div key={idx} className="text-center p-6 border border-background-200/60 bg-background-100/60">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center">
                <i className={`${cardIcons[idx]} text-2xl text-accent-500`}></i>
              </div>
              <h3 className="text-[16px] font-heading text-foreground-900 tracking-[0.05em] mb-2">
                {t(`materials.philosophy.card.${idx}.title`)}
              </h3>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                {t(`materials.philosophy.card.${idx}.text`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
